import styled from "styled-components";
import backSectionTwo from "../../assets/images/back-four.png";

export const Section = styled.section`
  background: url(${backSectionTwo}) no-repeat;
  background-size: cover;
  background-position: 0 100%;
  padding: 6rem 0;
`;

export const Container = styled.div`
  padding: 0 10rem;
  display: flex;
  justify-content: space-between;
  img {
    width: 50%;
  }
  @media only screen and (max-width: 1400px) {
    padding: 0 4rem;
  }
`;

export const RightSide = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
  max-width: 50%;
  margin-left: 50px;
  h1 {
    align-self: center;
    font-size: 60px;
    word-spacing: 100vw;
    margin-bottom: 30px;
    color: #131415;
  }
  span {
    color: #13141566;
    margin-bottom: 30px;
  }
`;
